// removed by extract-text-webpack-plugin
module.exports = {"gw-tile-footer__generic":"generic-tile-hashed__gw-tile-footer__generic__2yraX","gw-tile-header__generic":"generic-tile-hashed__gw-tile-header__generic__j_67C"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/Generic/generic-tile-hashed.scss
// module id = 1216
// module chunks = 0